import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';
import { CLOUD_FUNCTIONS } from '../../constants/firebase';
import { downloadCheckErrorMessage, downloadRefusalMessage } from './finalGate';

export type DownloadDocType = 'dmp' | 'consent_form' | 'crf_guide' | 'visit_packet';

/**
 * Asks the server whether a download is allowed. Returns the plain-language
 * refusal to show, or null when the download may go ahead. A permission refusal
 * blocks; any other failure of the check does not (a server outage must not strand users).
 */
export async function downloadBlockedReason(
  projectId: string | undefined,
  docType: DownloadDocType,
): Promise<string | null> {
  if (!projectId) return null;
  try {
    const fn = httpsCallable<{ projectId: string; docType: string }, { allowed: boolean; reasons: string[] }>(
      functions,
      CLOUD_FUNCTIONS.CHECK_DOWNLOAD_ALLOWED,
    );
    const res = await fn({ projectId, docType });
    return downloadRefusalMessage(res.data);
  } catch (e) {
    const denied = downloadCheckErrorMessage(e);
    if (denied) return denied;
    // Network or server trouble must not strand the user; the server still gates real downloads.
    console.warn('Download pre-check failed:', e);
    return null;
  }
}
